import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `downloadCommand` is the command used to download a file.
 * `downloadCommand` is valid if and only if one or multiple files are selected.
 */
export default class DownloadCommand extends AbstractEntryCommand {
	accept(aVisitor) {
		return aVisitor.visitDownloadCommand(this);
	}

	requireRefresh() {
		return false;
	}

	priority() {
		return 800;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	_performOnService() {
		this._documentService.executeDownloadCommand(this);
	}

	_execute() {
		selection.entries().forEach((entry) =>
			this._documentService.downloadFile({
				file: entry,
				forceDownload: true,
			}),
		);
	}

	static isApplicable() {
		return (
			selection.notEmpty() &&
			selection.every((elt) => elt.entry().isFile())
		);
	}
}
